import React, { Component } from 'react';
import { Col } from 'react-bootstrap/lib';
import { LoadingScreen } from '../../generic/input';
import { DAY, MAPS_API_KEY, MENUPATH } from '../../lib/enums';
import { DailyRide } from '../../generic/input.js';
import { StampTODate, timeFormat, parseMSIntoReadableTime } from '../../lib/dtconv';
import { getDayStats, GetStatsFromServer } from '../../db/stats';
import { TODAY_END_TS } from '../../lib/enums';
import { ShowErrorMsg } from '../../generic/genericFunctions';
import bgImage from "../../images/waitRide.png";
const { MapComponent } = require('../../lib/common');
const SPEED_THRESHOLD = 250;

export default class DetailedStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: { lat: 20.5837, lng: 78.9629 },
      stats: {},
      path: [],
      errMsg: ""
    }
    this.mapMounted = false;
    global.EE.addEventListener(global.EE.EVENT_TYPES.SAVED_LOC_FOR_DAY, this.savedLocForStats);

  }
  componentDidMount() {
    this.getDataForDay();
    global.EE.emitEvent(global.EE.EVENT_TYPES.MENU_CHANGE, MENUPATH.DAILY_RIDES);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.SAVED_LOC_FOR_DAY, this.savedLocForStats);
  }

  getDataForDay = () => {
    if (this.props.location.query.veh && this.props.location.query.ts) {
      let vid = parseInt(this.props.location.query.veh);
      let ts = parseInt(this.props.location.query.ts);
      getDayStats(vid, ts, (err, stats) => {
        if (err) {
          this.setState({
            errMsg: "Server unavailable please try again later"
          });
        } else {
          if (stats) {
            if (stats.loc && stats.loc.length) {
              this.setState({
                stats: stats,
                path: stats.loc.filter(p => p.lat && p.lng)
              })
            } else {
              global.EE.emitEvent(global.EE.EVENT_TYPES.GET_LOC_FOR_DAY, { vid, ts });
            }
          } else {
            let params = { vids: [vid], from: ts, to: TODAY_END_TS } // Latest daily stats wts
            // Get the daily stats from the selected day to now so that daily stats tiles shown correctly

            GetStatsFromServer(params, (e, dailyStats) => {
              if (e) {
                this.setState({
                  errMsg: "Server unavailable please try again later"
                });
              } else {
                if (dailyStats && dailyStats) {
                  let selStats = dailyStats.filter(ds => { return (ds.ts === ts && ds.vid === vid) });
                  if (selStats && selStats.loc && selStats.loc.length) {
                    this.setState({
                      stats: stats,
                      path: stats.loc
                    })
                  } else global.EE.emitEvent(global.EE.EVENT_TYPES.GET_LOC_FOR_DAY, { vid, ts });
                }
              }
            });
          }
        }
      })
    } else {
      var newUrl = "/webapptl/dailyStats";
      this.props.router.replace(newUrl);
    }
  }

  savedLocForStats = (stats) => {
    this.setState({
      stats: stats,
      path: stats.loc || []
    });
  }

  showStats(stat) {
    var dt, midnight;
    dt = new Date(stat.ts);
    midnight = new Date().setHours(0, 0, 0, 0);
    return (
      <div className="col-sm-12 col-xs-12">
        <div className="font-size16px" style={{ marginTop: "2%", marginBottom: "3%" }}>{dt.getTime() < midnight ? StampTODate(dt) + " " + DAY[dt.getDay()] : "Today"}</div>
        <div>
          {DailyRide("Distance", stat.dst ? ((stat.dst) / 1000).toFixed(1) + " Km" : "-")}
          {DailyRide("Duration", stat.dur ? parseMSIntoReadableTime(stat.dur * 1000) : "-")}
          {DailyRide("Start", stat.sdt ? timeFormat(stat.sdt * 1000) : "")}
          {DailyRide("End", stat.edt ? timeFormat(stat.edt * 1000) : "-")}
          {DailyRide("AVG Speed", stat.avs ? stat.avs < SPEED_THRESHOLD ? stat.avs.toFixed(2) + " Km/h" : SPEED_THRESHOLD + " Km/h" : "-")}
          {DailyRide("Top Speed", stat.tps && stat.tps < SPEED_THRESHOLD ? stat.tps.toFixed(2) + " Km/h" : SPEED_THRESHOLD + " Km/h")}
          {stat.mang ? DailyRide("Max Lean Angle", stat.mang.toFixed(2) + "°") : ""}
          {DailyRide("Engine On Duration", stat.ignOnDur ? parseMSIntoReadableTime(stat.ignOnDur * 1000) : "-", null)}
          {this.state.path && this.state.path.length && global.userId ?
            DailyRide("Download",
              <button className="btn-primary" style={{ borderRadius: "4px", padding: "1px" }} title="Download CSV" onClick={this.downloadCSV}>
                <i className="ajjas-cloud" style={{ fontSize: "24px" }} />
              </button>
            ) : null
          }
        </div>
      </div>
    )
  }

  handleMapMounted = (map) => {
    if (this.mapMounted) return;
    var bounds = new window.google.maps.LatLngBounds();
    this.state.path.forEach((path) => {
      bounds.extend(new window.google.maps.LatLng(path.lat, path.lng));
    })
    this._ref.fitBounds(bounds);
    this.mapMounted = true;
  }

  _onChange(latlng, zoom) {
    this.setState({
      zoom: zoom,
      center: this._ref.getCenter()
    })
  }

  mapDisplay() {
    var latlng = { lat: this.state.path[0].lat, lng: this.state.path[0].lng };
    return (
      <div className="margin-bottom15 map">
        <MapComponent
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&v=3.exp&libraries=drawing,places`}
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: '50vh' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          center={this.state.center}
          zoom={this.state.zoom}
          onZoomChanged={() => this._onChange(latlng, this.state.zoom)}
          trafficCheck={this.state.trafficCheck}
          pathTrail={this.state.path}
          regionA={latlng}
          regionB={{ lat: this.state.path[this.state.path.length - 1].lat, lng: this.state.path[this.state.path.length - 1].lng }}
          onMapIdle={this.handleMapMounted}
          referance={(ref) => this._ref = ref}
        />
      </div>
    )
  }

  render() {
    return (
      <Col lg={10} md={9} sm={12} xs={12} className="border-gray" style={{ paddingLeft: "0%", paddingRight: "0%", paddingBottom: "15px" }}>
        { Object.keys(this.state.stats).length ? this.showStats(this.state.stats) : null}
        {
          this.state.path.length > 0 ?
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 leftRight_padding" >{this.mapDisplay()}</div>
            :
            this.state.errMsg ?
              <div className="height-75vh">
                {ShowErrorMsg(this.state.errMsg, bgImage)}
              </div>
              : <LoadingScreen />
        }
      </Col>
    )
  }
}